import { shouldShowCWQALog } from "../../../utils/shouldShowCWQALog";

interface CWUserGenderParams {
  userGender: {
    gender: string;
  };
}

export const useCWuserGenderEvent = ({ userGender }: CWUserGenderParams): void => {
  const eventData = {
    gender: userGender.gender,
  };

  shouldShowCWQALog() && console.log(`cw_user_gender event:`, eventData);
  window.gtag("event", "cw_user_gender", eventData);
};